export default __webpack_public_path__ + "static/media/quote.58e3c5ff.svg";